/** Shared slots keep a dashboard hero stable through its nested roster read. */
export const HERO_LAYOUT = {
  card: 'flex flex-col gap-3',
  heading: 'flex min-h-12 items-start gap-2',
  metric: 'flex min-h-14 items-center gap-3',
  meta: 'min-h-10 text-small sm:min-h-5',
  meter: 'h-14',
  legend: 'flex min-h-16 flex-wrap items-center gap-x-4 gap-y-1 text-small sm:min-h-5',
  action: 'flex min-h-11 items-center gap-2 text-small',
} as const

/** The overview answer card keeps its four slots through the initial workspace read. */
export const ANSWERS_LAYOUT = {
  card: 'flex flex-col gap-3',
  heading: 'min-h-12',
  metric: 'flex min-h-14 items-center gap-3',
  meter: 'h-14',
  legend: 'flex min-h-18 flex-wrap items-center gap-x-4 gap-y-2 text-small',
} as const

/**
 * The overview's bento row. Fixed spans in a 12-column grid (hero 5, forms 4 each, placement 3,
 * steps 7 or 12) only tile for one card count: 5+4 then 4+3 left a third of each row empty
 * (triple assessment 30.10.2026). From lg the row wraps and every card grows from its share, so
 * each row closes at the edge whatever the count. One column below lg, as before.
 */
export const BENTO_ROW = 'grid grid-cols-1 gap-4 lg:flex lg:flex-wrap' as const
export const BENTO_SPAN = {
  3: 'lg:grow lg:basis-[calc(25%-1rem)]',
  4: 'lg:grow lg:basis-[calc(100%/3-1rem)]',
  5: 'lg:grow lg:basis-[calc(500%/12-1rem)]',
  7: 'lg:grow lg:basis-[calc(700%/12-1rem)]',
  12: 'lg:basis-full',
} as const

export const OPERATIONS_SUPPORT_LAYOUT = { form: `min-h-54 ${BENTO_SPAN[4]}`, placement: `min-h-59 ${BENTO_SPAN[3]}` } as const
